/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentFirstBuyerStep_root$ref: FragmentReference;
declare export opaque type DevelopmentFirstBuyerStep_root$fragmentType: DevelopmentFirstBuyerStep_root$ref;
export type DevelopmentFirstBuyerStep_root = {|
  +me: ?{|
    +id: string,
    +firstName: ?string,
    +dateOfBirth: ?string,
    +nationality: ?{|
      +id: string,
      +label: string,
      +name: string,
    |},
    +occupation: ?{|
      +id: string,
      +label: string,
    |},
    +workPermit: ?{|
      +id: string
    |},
  |},
  +workPermitTypes: $ReadOnlyArray<{|
    +id: string,
    +label: string,
    +name: string,
  |}>,
  +occupationTypes: $ReadOnlyArray<{|
    +id: string,
    +label: string,
    +name: string,
  |}>,
  +nationalityTypes: $ReadOnlyArray<{|
    +id: string,
    +label: string,
    +name: string,
  |}>,
  +$refType: DevelopmentFirstBuyerStep_root$ref,
|};
export type DevelopmentFirstBuyerStep_root$data = DevelopmentFirstBuyerStep_root;
export type DevelopmentFirstBuyerStep_root$key = {
  +$data?: DevelopmentFirstBuyerStep_root$data,
  +$fragmentRefs: DevelopmentFirstBuyerStep_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentFirstBuyerStep_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateOfBirth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Dictionary",
          "kind": "LinkedField",
          "name": "nationality",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Dictionary",
          "kind": "LinkedField",
          "name": "occupation",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Dictionary",
          "kind": "LinkedField",
          "name": "workPermit",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "workPermitTypes",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "work_permit_types"
        }
      ],
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "dictionaries",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": "dictionaries(type:\"work_permit_types\")"
    },
    {
      "alias": "occupationTypes",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "occupation_types"
        }
      ],
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "dictionaries",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": "dictionaries(type:\"occupation_types\")"
    },
    {
      "alias": "nationalityTypes",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "nationality_types"
        }
      ],
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "dictionaries",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": "dictionaries(type:\"nationality_types\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '89dca5b23169cf121b5dcac729ff74ae';

export default node;
